import type {
  GetProductProjectionById200,
  ProductProjection,
} from '@unity/commerce-bridge';
import type { AxiosInstance } from 'axios';

export const buildProductProjectionPath = (productId: string): string =>
  `/commerce/bridge/v1/product-projections/${encodeURIComponent(productId)}`;

export type FetchProductProjection = (
  productId: string
) => Promise<ProductProjection | undefined>;

/**
 * Reads one commercetools product projection by id, for a save-for-later on a
 * line item whose product the cart has not loaded yet. The route needs no
 * bridge token. Successful reads are cached for the island's lifetime;
 * failures are not, so a later click retries.
 */
export const createProductProjectionFetcher = (
  client: AxiosInstance
): FetchProductProjection => {
  const cache = new Map<string, Promise<ProductProjection | undefined>>();
  return (productId) => {
    const cached = cache.get(productId);
    if (cached) return cached;
    const request = client
      .get<GetProductProjectionById200>(buildProductProjectionPath(productId))
      .then(({ data }) => data?.body?.data);
    request.catch(() => cache.delete(productId));
    cache.set(productId, request);
    return request;
  };
};
